const shadows = {
  light: `0px 6px 20px rgba(0, 0, 0, 0.1)`,
}

export default shadows
